import { Component, OnInit, Injector, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SecondPageEditBase } from '../../lib-shared/classes/base/second-page-edit-base';
import { ActiveCommentInterface } from '../../lib-shared/types/activeComment.interface';
import { User } from '../../lib-shared/models/user';
import { ActiveCommentTypeEnum } from '../../lib-shared/types/activeCommentType.enum';
import { WmTaskCommentLikesService } from '../../work/services/WmTaskCommentLikes.service';

interface data {
  text: String,
  parentId: number
}

@Component({
  selector: 'app-comment-g',
  templateUrl: './comment-g.component.html',
  styleUrls: ['./comment-g.component.scss']
})
export class CommentGComponent extends SecondPageEditBase implements OnInit, OnChanges {

  @Input() comment!: any;
  @Input() replies!: any[];
  @Input() activeComment!: ActiveCommentInterface | null;
  @Input() parentId!: number;
  @Input() currentUser: User;

  @Output() deleteComment = new EventEmitter<number>();
  @Output() updateComment = new EventEmitter<{ text: string; commentId: number }>();
  @Output() addComment = new EventEmitter<{ text: string; parentId: number }>();
  @Output() setActiveComment = new EventEmitter<ActiveCommentInterface | null>();

  @Output() emitData = new EventEmitter<data>();

  activeCommentType = ActiveCommentTypeEnum;
  replyId: number = null;
  canEdit: boolean = false;
  canDelete: boolean = false;
  isReplyingComment: boolean = false;
  isEditingComment: boolean = false;

  constructor(
    protected _injector: Injector,
    private _WmTaskCommentLikesService: WmTaskCommentLikesService,
  ) {
    super(null, _injector);
  }

  ngOnInit() {
    this.replyId = this.parentId ? this.parentId : this.comment.id;
    this.canEdit = this.currentUser.userId == this.comment.userCreated.userId;
    this.canDelete = this.currentUser.userId == this.comment.userCreated.userId;
    this.updateActiveState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeComment']) {
      this.updateActiveState();
    }
  }

  private updateActiveState() {
    if (!this.activeComment) {
      this.isReplyingComment = false;
      this.isEditingComment = false;
    } else {
      this.isReplyingComment = this.activeComment.id === this.comment.id && this.activeComment.type === 'replying';
      this.isEditingComment = this.activeComment.id === this.comment.id && this.activeComment.type === 'editing';
    }
  }

  async likeComments(idTaskComment, idTask) {
    await this._WmTaskCommentLikesService.Like(idTaskComment, idTask)
      .then(async response => {
        if (response.status) {
          this.comment.userLiked = !response.data.isDeleted;
          if (!response.data.isDeleted) {
            this.comment.countLike++;
            this.comment.likeUser.push({
              userId: this.currentUser.userId,
              name: this.currentUser.userName
            })
          }
          else {
            this.comment.countLike--;
            let indexUser = this.comment.likeUser.findIndex(x => x.userId == this.currentUser.userId);
            this.comment.likeUser.splice(indexUser, 1);
          }

        }
      }, () => {
        this._notifierService.showHttpUnknowError();
      });
  }

}
